import { renderInvalidatedColors } from './chart-util';

/**
 * Adds options for LINE charts.
 */
export function preRender(data, options) {
  let radius = 0;
  let hoverRadius = 2.5;
  if (options.markedDataPoints) {
    if (options.print)  !options.step ? radius = 1.25 : radius = 0;
    else {
      radius = !options.step ? 2.5 : 0;
      hoverRadius = !options.step ? 3.5 : 0;
    } 
  }
  const showOnHover = options.showTooltips;
  data.plotOptions.line = {
    lineWidth: 2,
    linecap: 'square',
    enableMouseTracking: options.interactive,
    states: {
      hover: {
        halo: {
          opacity: 1,
          size: hoverRadius
        },
        lineWidthPlus: 0
      }
    },
  };
  data.plotOptions.series = {
    marker: {
      symbol: 'circle',
      radius: radius,
      lineWidth: 0,
      lineColor: null,
      enabled: options.markedDataPoints,
      states: {
        hover: {
          enabled: showOnHover
        }
      }
    },
    dataGrouping: {
      enabled: !options.irregularDates
    }
  };
  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      data.plotOptions.line.lineWidth = 1.5;
      data.plotOptions.line.linecap = 'round';
    }
  }
  return data;
}


export function postRender(highchart, options) {
  updateDashStyle(highchart, options); 
  roundLineJoins(highchart);
}

function updateDashStyle(highchart, options) {
  const paths = [...highchart.container.querySelectorAll('.highcharts-graph')];
  paths.forEach(path => {
    const dashArray = path.getAttribute('stroke-dasharray');
    if (dashArray !== 'none') {
      const [width, gap] = options.size === 'print-wsj' ? [1.5, 3] : [2.5, 5];
      path.setAttribute('stroke-width', width);
      path.setAttribute('stroke-dasharray', `0.1,${gap}`);
      path.setAttribute('stroke-linecap', 'round');
    }
  })
}

function roundLineJoins(highchart) {
  const selector = 'g.highcharts-series-group g.highcharts-series path';
  const paths = highchart.container.querySelectorAll(selector);
  for (let i = 0; i < paths.length; i++) {
    paths[i].setAttribute('stroke-linejoin', 'bevel');
  }
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    renderInvalidatedColors(rendered, invalidated);
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/chart-line.js